import { Badge, Checkbox, Dropdown, DropdownProps, Flex, Input, MenuProps, Tag } from "antd";
import { IoSearch } from "react-icons/io5";
import { LuSettings2 } from "react-icons/lu";
import { AppDispatch, RootState } from "../../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import ModalWrapper from "../../generic/modal";
import { SearchConversationList } from "./SearchConversations.list";
import { fetchConversationByParticipants, fetchConversationsStats } from "../../../hooks/apis/conversations.api";
import { ConversationsStats } from "../../../interfaces/conversations.type";
import NewConversationModal from "./NewConversationModal";
import { formatPhoneNumber } from "../../../utils/phoneLib";
import { setSelectedConversation } from "../../../store/slices/conversation.slice";

export const ConversationHeader = ({
    setConversationsFilter,
    convsersationsFilter,
    setParticipants,
    setIsNewConversation,
}: {
    setConversationsFilter: Function;
    convsersationsFilter: {
        unread: boolean;
        assigned: boolean;
        unresolved: boolean;
        resolved: boolean;
        unassigned: boolean;
        assigned_user: string;
    };
    setParticipants: Function;
    setIsNewConversation: Function;
}) => {
    const dispatch: AppDispatch = useDispatch();
    const searchIconStyle: React.CSSProperties = {
        height: "20px",
        width: "20px",
        color: "#6b7280",
        cursor: "pointer"
    };

    const settingIconStyle: React.CSSProperties = {
        height: "33px",
        width: "33px",
        marginTop: "7px",
        cursor: "pointer"
    };

    const inputSearchStyle: React.CSSProperties = {
        borderRadius: "25px",
        border: "none",
        background: "#f5f6f7",
        padding: "10px"
    };



    const boxStyle: React.CSSProperties = {
        borderBottom: "1px solid rgb(223, 226, 232)",
        minHeight: "70px",
        padding: "13px"
    };


    const [open, setOpen] = useState(false);
    const [searchModal, setSearchModal] = useState(false);

    const { data: user } = useSelector((state: RootState) => state.sessionData);
    const accountID = useSelector((state: RootState) => state.admin.selectedAccount);
    const { selectedDid } = useSelector((state: RootState) => state.smsDids);

    const [conversationsStats, setConversationsStats] = useState<ConversationsStats>();

    useEffect(() => {
        if (!selectedDid || !convsersationsFilter) return;

        fetchConversationsStats({
            did: selectedDid,
            account: accountID,
            ...convsersationsFilter,
        }).then(stats => setConversationsStats(stats));
    }, [convsersationsFilter])

    const handleOpenChange: DropdownProps["onOpenChange"] = (nextOpen, info) => {
        if (info.source === "trigger" || nextOpen) {
            setOpen(nextOpen);
        }
    };

    const filterItems = [
        {
            label: `Unread `,
            value: "unread",
            key: "1"
        },
        {
            label: "My conversations",
            value: "assigned_user",
            key: "2"
        },
        {
            label: "Assigned",
            value: "assigned",
            key: "3"
        },
        {
            label: "Unassigned",
            value: "unassigned",
            key: "4"
        },
        {
            label: "Resolved",
            value: "resolved",
            key: "5"
        },
        {
            label: "Unresolved",
            value: "unresolved",
            key: "6"
        }
    ];

    const items: MenuProps["items"] = filterItems.map(item => {
        return {
            label: (
                <Checkbox
                    className="conversation-filter-checkbox"
                    onChange={e => {
                        setConversationsFilter({
                            ...convsersationsFilter,
                            [item.value]:
                                item.value === "assigned_user"
                                    ? e.target.checked
                                        ? user?.id
                                        : undefined
                                    : e.target.checked
                                        ? true
                                        : undefined
                        });
                    }}
                    style={{ width: "100%" }}
                    value={convsersationsFilter[item.value as keyof typeof convsersationsFilter]}
                    checked={convsersationsFilter[item.value as keyof typeof convsersationsFilter] ? true : false}
                >
                    <Flex style={{ width: "100%", gap: "10px" }} justify="space-between" align="center">
                        <span style={{ flex: 1, textAlign: "left" }}>{item.label}</span>

                    </Flex>
                </Checkbox>
            ),
            key: item.key
        };
    });

    return (
        <Flex style={boxStyle} gap={10} vertical>
            <Flex justify={"space-between"} align={"flex-start"}>
                {searchModal && (
                    <ModalWrapper title="Search Messages" setIsModalOpen={setSearchModal} isModalOpen={searchModal}>
                        <SearchConversationList setIsmodal={setSearchModal} setIsNewConversation={setIsNewConversation} />
                    </ModalWrapper>
                )}
                {
                    selectedDid ? (
                        <Flex align="center" gap={10}>
                            <NewConversationModal
                                onParticipantsSubmit={async (phoneNumbers) => {
                                    try {
                                        const conversation = await fetchConversationByParticipants(
                                            selectedDid,
                                            phoneNumbers,
                                        );

                                        if (conversation) {
                                            dispatch(setSelectedConversation({
                                                conversation_id: conversation.id,
                                                did: conversation.did,
                                                participants: conversation.participants,
                                                type: conversation.type,
                                                unread_messages_count: conversation.unread_messages_count,
                                            }));
                                            setParticipants([]);
                                            setIsNewConversation(false);
                                            return;
                                        }
                                    } catch {
                                        // Fall back to a new draft if the history lookup fails.
                                    }

                                    dispatch(setSelectedConversation(null));
                                    setParticipants(phoneNumbers);
                                    setIsNewConversation(true);
                                }}
                            />
                            <span style={{ fontSize: "16px", fontWeight: 500, color: "#111827" }}>
                                {formatPhoneNumber(selectedDid)}
                            </span>
                        </Flex>
                    ) : <div></div>
                }

                {
                    selectedDid && <Flex>
                        <div onClick={() => setSearchModal(true)}>
                            <Input
                                className={"search-conversation-input"}
                                style={{
                                    ...inputSearchStyle
                                }}
                                size="middle"
                                placeholder="Search"
                                prefix={<IoSearch style={searchIconStyle} />}
                            />
                        </div>
                        <Flex align="center" style={{ gap: 8 }}>
                            <Dropdown menu={{ items }} onOpenChange={handleOpenChange} open={open} trigger={["click"]}>
                                <LuSettings2 style={settingIconStyle} strokeWidth={1} />
                            </Dropdown>
                        </Flex>
                    </Flex>
                }

            </Flex>
            {Object.keys(convsersationsFilter).filter(key => convsersationsFilter[key as keyof typeof convsersationsFilter]).length > 0 && (
                <Flex gap={6} wrap="wrap">
                    {Object.keys(convsersationsFilter)
                        .filter(key => convsersationsFilter[key as keyof typeof convsersationsFilter])
                        .map(key => {
                            return (
                                <Tag
                                    style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}
                                    color="geekblue"
                                    key={key}
                                >
                                    {filterItems.find(item => item.value === key)?.label}
                                    {
                                        conversationsStats?.[key as keyof typeof conversationsStats] !== undefined &&
                                        conversationsStats?.[key as keyof typeof conversationsStats] != 0 &&
                                        <Badge
                                            count={conversationsStats?.[key as keyof typeof conversationsStats] || 0}
                                            showZero={false}
                                            overflowCount={999}
                                            className="conversation-filter-badge"
                                            color="#653BFA"
                                            style={{
                                                minWidth: 28,
                                                width: 28,
                                                padding: "2px !important",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontVariantNumeric: "tabular-nums",
                                                textAlign: "center"
                                            }}
                                        />
                                    }
                                </Tag>
                            );
                        })}
                    <Tag style={{ cursor: "pointer" }} onClick={() => setConversationsFilter({})}>
                        clear
                    </Tag>
                </Flex>
            )}
        </Flex>
    );
};
